export enum MemberAllowedResourcesLookup {
    MyProfile = 62,
    OrderHistory = 63,
    Autoship = 64,
    CCSnapshot = 65,
    SavedPayments = 66,
    SavedAddresses = 67,
    Password = 68,
    CommunicationPreferences = 69,
    MyReviews = 70,
    MyStore = 71,
    ForeverBusinessOwnerSetup = 85,
    DashBoard = 86,
    MyActionCenter = 87
}
